import {
  DownloadOutlined,
  EyeOutlined,
  FileTextOutlined,
  FolderFilled,
  InboxOutlined,
  PictureOutlined,
  RightOutlined,
} from '@ant-design/icons'
import { Row, Image } from 'antd'
import { includes, toUpper } from 'lodash'
import React, { useState, useEffect } from 'react'
import '../../../styleLess/signature/projectfile.scss'
import { DATA_CHANG_PROJECT_FILE } from 'api/Overview/overview'
import { getCookie } from 'helper/cookie'
import { useParams, useLocation, useHistory } from 'react-router-dom'
import loadingAnimationthreedot from 'icons/three-dots.svg'
import GetURL from 'common/GetURLDocument/getURLCommon'

const ProjectFile = () => {
  let sprintflowId = ''
  const { id } = useParams()
  const history = useHistory()
  const dataProject = useLocation().state
  const token = getCookie('access_token_admin')
  const [dataList, setDataList] = useState([])
  const [textlevel1, setTextlevel1] = useState('')
  const [textlevel2, setTextlevel2] = useState('')
  const [saveForbackId, setSaveforbackId] = useState('')
  const [saveForbackId2, setSaveforbackId2] = useState('')
  const [loading, setLoading] = useState(false)
  const [zIndexContent, setZIndexContent] = useState(false)

  //getURL
  const [getURL, setGetURL] = useState(false)
  const [dataGetURL, setDataGetURL] = useState(false)
  const [dataGetURLType, setDataGetURLType] = useState(false)
  const [loadingGetURL, setLoadingGetURL] = useState(false)

  const GET_RESPON_DATA = async () => {
    setLoading(true)
    const Query = {
      id_project: id,
      sprintflow_id: sprintflowId,
    }

    await DATA_CHANG_PROJECT_FILE({
      params: Query,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          await setDataList([])
          return true
        }
        if (status === 200) {
          await setDataList(data)
          setLoading(false)
          setZIndexContent(true)
        } else {
          setZIndexContent(true)
          await setDataList([])
          setLoading(false)
          return true
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }

  useEffect(() => {
    if (token) {
      GET_RESPON_DATA()
    }
  }, [token])

  const checkType_Icon = (type) => {
    if (type === 'image') {
      return <PictureOutlined className='icontype' />
    } else if (type === 'document') {
      return <FileTextOutlined className='icontype' />
    } else if (type === 'folder') {
      return <FolderFilled className='icontype' />
    }
  }

  // console.log('เข้า')

  const checkType_OnClick = (data) => {
    if (data.kind === 'folder') {
      return (
        <div className='area-type-files'>
          {checkType_Icon(data.kind)}
          <p
            className='responsive-text-filesname'
            style={{ cursor: 'pointer' }}
            onClick={() => NICOLAS_FUNCTIONAL(data)}
          >
            {data.title}
          </p>
        </div>
      )
    } else {
      return (
        <div className='area-type-files'>
          {checkType_Icon(data.kind)}
          <p className='responsive-text-filesname'>{data.title}</p>
        </div>
      )
    }
  }

  const onClickEye = (data, type) => {
    setGetURL(true)
    setDataGetURL(data)
    setDataGetURLType(type)
  }

  const checkType_FunctionUse = (data) => {
    if (data != undefined) {
      if (data.kind !== 'folder') {
        let lastnameFILE = data.title.split('.')
        if (
          ['jpg', 'jpeg', 'png', 'JPG', 'JPEG', 'PNG'].includes(
            lastnameFILE[lastnameFILE.length - 1],
          )
        ) {
          return (
            <div className='styles-eye-and-download'>
              <div className='position-viewer'>
                {loadingGetURL == true ? (
                  <img
                    style={{ width: 24, height: 12, marginLeft: -8 }}
                    src={loadingAnimationthreedot}
                  ></img>
                ) : (
                  <EyeOutlined
                    className='eyeoutlined'
                    onClick={() => onClickEye(data, 'preview')}
                    style={{ position: 'absolute' }}
                  />
                )}
              </div>
              <DownloadOutlined
                onClick={() => onClickEye(data, 'download')}
                className='downloadoutlined'
                style={{ justifySelf: 'flex-end' }}
              />
            </div>
          )
        } else {
          return (
            <div className='styles-eye-and-download'>
              <div className='position-viewer'>
                {loadingGetURL == true ? (
                  <img
                    style={{ width: 24, height: 12 }}
                    src={loadingAnimationthreedot}
                  ></img>
                ) : (
                  <EyeOutlined
                    onClick={() => onClickEye(data, 'preview')}
                    className='eyeoutlined'
                  />
                )}
              </div>
              <DownloadOutlined
                className='downloadoutlined'
                onClick={() => onClickEye(data, 'download')}
                style={{ justifySelf: 'flex-end' }}
              />
            </div>
          )
        }
      } else {
        return <></>
      }
    }
  }

  const displayFunctional = () => {
    if (loading === true) {
      return <div></div>
    } else if (loading === false) {
      if (dataList.length == 0) {
        return ''
      } else {
        return dataList.map((item) => {
          return (
            <tr className='tr2'>
              <td className='td1'>{checkType_OnClick(item)}</td>
              <td className='td2'>
                <p>{item.updated_at}</p>
              </td>
              <td className='td3'>
                <p> {toUpper(item.filesize_text)}</p>
              </td>
              <td className='td4'>
                <p>
                  {item.firstname} {item.lastname}
                </p>
              </td>
              <td className='td5'>{checkType_FunctionUse(item)}</td>
            </tr>
          )
        })
      }
    }
  }

  const NICOLAS_FUNCTIONAL = (data) => {
    if (data.level == 0) {
      setTextlevel1(data.title)
      setSaveforbackId(data.sprintflow_id)
    } else if (data.level == 1) {
      setTextlevel2(data.title)
      setSaveforbackId2(data.sprintflow_id)
    }

    sprintflowId = data.sprintflow_id
    GET_RESPON_DATA()
  }

  const CallbackRenderler = (values) => {
    setZIndexContent(false)
    if (values === 'level0') {
      setTextlevel2('')
      setTextlevel1('')
      sprintflowId = ''
      GET_RESPON_DATA()
    } else if (values === 'level1') {
      setTextlevel2('')
      sprintflowId = saveForbackId
      GET_RESPON_DATA()
    } else if (values === 'level2') {
      sprintflowId = saveForbackId2
      GET_RESPON_DATA()
    }
  }
  const goProjectList = () => {
    history.push('/project-list')
  }
  const goOverView = () => {
    history.push(`/overview/${id}`)
  }
  return (
    <div className='projectfile-container'>
      <div className='layout-top'>
        <Row className='bredcramp-con'>
          <h4
            className='bred1'
            style={{ cursor: 'pointer' }}
            onClick={() => goProjectList()}
          >
            Project
          </h4>
          <RightOutlined className='ic' />
          <h4
            className='bred2'
            style={{ cursor: 'pointer' }}
            onClick={() => goOverView()}
          >
            {dataProject.name}
          </h4>
          <RightOutlined className='ic' />
          <h4 className='bred3'>Project Files</h4>
        </Row>
        <h1>Project Files</h1>
      </div>
      <div className='layout-body'>
        <Row className='styler-path-area'>
          <h4 className='nameProject-text' onClick={() => CallbackRenderler('level0')}>
            {dataProject.name}
          </h4>
          <Row>
            {textlevel1 !== '' ? (
              <p onClick={() => CallbackRenderler('level1')} className='level1-style'>
                / {textlevel1}
              </p>
            ) : (
              ''
            )}
            {textlevel2 !== '' ? (
              <p onClick={() => CallbackRenderler('level2')} className='level2-style'>
                / {textlevel2}
              </p>
            ) : (
              ''
            )}
          </Row>
        </Row>

        <div className='content'>
          <table className='table-log-files'>
            <tr className='tr1'>
              <th className='th1'>
                <h5>Name</h5>
              </th>
              <th className='th2'>
                <h5>DateModifield</h5>
              </th>
              <th className='th3'>
                <h5>Size</h5>
              </th>
              <th className='th4'>
                <h5>Owner</h5>
              </th>
            </tr>
            {displayFunctional()}
          </table>
          {dataList.length == 0 && zIndexContent === true ? (
            <div className='projectfile-emytystate'>
              <InboxOutlined className='inbox' />
              <p>No Document</p>
            </div>
          ) : (
            ''
          )}
          {loading === true ? (
            <div className='container-waiting-load'>
              <img src={loadingAnimationthreedot}></img>
            </div>
          ) : (
            ''
          )}

          {loading === false ? (
            dataList.length != 0 ? (
              <div className='responsive-content-files'>
                {dataList.map((item) => {
                  return (
                    <Row className='style-rows-files'>
                      {checkType_OnClick(item)}
                      {checkType_FunctionUse(item)}
                    </Row>
                  )
                })}
              </div>
            ) : (
              ''
            )
          ) : (
            ''
          )}
        </div>
      </div>

      <GetURL
        project_id={dataGetURL.project_id}
        id_document={dataGetURL.id}
        type={dataGetURLType}
        dataFile={dataGetURL}
        setGetURL={setGetURL}
        getURL={getURL}
        setLoadingGetURL={setLoadingGetURL}
        state='Overview'
      />
    </div>
  )
}
export default ProjectFile
